import {WOFSlice} from '@src/Components/SharedConfigProvider';

import * as classes from './SingleWOFSlice.module.scss';

interface Props {
	type: WOFSlice;
	sliceIndex: number;
	totalSlices: number;
}

const SingleWOFSlice = (props: Props) => {
	const titleMap = {
		[WOFSlice.Prize1]: '1. Preis',
		[WOFSlice.Prize2]: '2. Preis',
		[WOFSlice.Prize3]: '3. Preis',
		[WOFSlice.NoPrize]: 'Oh Nein!',
	};

	const colorMap = {
		[WOFSlice.Prize1]: 'var(--color-primary)',
		[WOFSlice.Prize2]: 'var(--color-secondary)',
		[WOFSlice.Prize3]: '#57c7ff',
		[WOFSlice.NoPrize]: 'var(--color-lowlight)',
	};

	const backgroundMap = {
		[WOFSlice.Prize1]: '#008ed433',
		[WOFSlice.Prize2]: '#27b6fd1c',
		[WOFSlice.Prize3]: '#ffffff33',
		[WOFSlice.NoPrize]: '#eee3',
	};

	const rotate = `${((360 / props.totalSlices) * (props.sliceIndex - 1)).toString()}deg`;
	const aspectRatio = 1 / (2 * Math.tan(Math.PI / props.totalSlices));

	return (
		<div
			className={classes.slice}
			style={{
				color: colorMap[props.type],
				backgroundColor: backgroundMap[props.type],
				rotate,
				aspectRatio,
			}}
		>
			<div className={classes.sliceContent}>{titleMap[props.type]}</div>
		</div>
	);
};

export default SingleWOFSlice;
